var map = {
	"./ali-elahi.jpg": "./src/assets/employees/ali-elahi.jpg",
	"./alireza-khabbazzadeh.jpg": "./src/assets/employees/alireza-khabbazzadeh.jpg",
	"./amirhosein-karbasi.jpg": "./src/assets/employees/amirhosein-karbasi.jpg",
	"./amirhossein-abdollahi.jpg": "./src/assets/employees/amirhossein-abdollahi.jpg",
	"./arshia-nazarlotfi.jpg": "./src/assets/employees/arshia-nazarlotfi.jpg",
	"./ayda-diakouhi.jpeg": "./src/assets/employees/ayda-diakouhi.jpeg",
	"./esmail-noorani.jpg": "./src/assets/employees/esmail-noorani.jpg",
	"./farshad-mahmoudi.jpg": "./src/assets/employees/farshad-mahmoudi.jpg",
	"./fereshte-abdollahi-1.jpg": "./src/assets/employees/fereshte-abdollahi-1.jpg",
	"./golnaz-mobin.jpg": "./src/assets/employees/golnaz-mobin.jpg",
	"./haleh-jahangiri.jpg": "./src/assets/employees/haleh-jahangiri.jpg",
	"./khorram-ahmadzadeh.jpg": "./src/assets/employees/khorram-ahmadzadeh.jpg",
	"./nazli-hosseini.png": "./src/assets/employees/nazli-hosseini.png",
	"./poorya-rastgar.jpg": "./src/assets/employees/poorya-rastgar.jpg",
	"./rouhallah1-khakpour.jpg": "./src/assets/employees/rouhallah1-khakpour.jpg",
	"./vahid-ahmadzadeh.jpg": "./src/assets/employees/vahid-ahmadzadeh.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/employees sync \\.(png%7Cjpe?g)$";